import { EntityId } from '@smartsheet-dataflow/formjs-react';
import { TextArea } from '@smartsheet/lodestar-core';
import React from 'react';

export interface InputTextAreaProps extends EntityId {
  value: string;
  onChange: any;
  readonly: boolean;
}

export const InputTextArea = ({
  id,
  value,
  onChange,
  readonly,
}: InputTextAreaProps) => {
  return (
    <TextArea
      id={id}
      value={value}
      onChange={onChange}
      readOnly={readonly}
      disableManualResize
    />
  );
};
